export const mq = (size) => `@media (min-width: ${size})`;
